module.exports = __webpack_public_path__ + "img/benefits-slider-5.c253f89b.png";